export default import.meta.ROLLDOWN_FILE_URL_tgItkVM6JTrfm2CiQnzY5g